<template>
	<div class="full-width">
		<v-layout row wrap style="overflow: auto">
			<v-flex xs12 v-if="searchOn">
				<h5 class="mb-4 title">
					Found {{ allData.length }} results from
					{{ totalLength }} rows
				</h5>
			</v-flex>
			<v-flex>
				<table
					class="full-width table-default table--thin mb-5"
					:class="isTableInteractive ? 'table--interactive' : ''"
				>
					<thead>
						<th v-if="noPagination">S. No.</th>
						<th
							v-for="(item, index) in allProps"
							:key="index"
							style="text-align:center"
						>
							<a
								@click="setOrderProperty(item.key)"
								class="grey--text text--darken-3"
								:class="{
									'sorted-column': item.key === orderByProp
								}"
								>{{ item.text }}</a
							>
						</th>
					</thead>
					<tbody>
						<tr
							v-for="(item, i) in allSlicedData"
							:key="item[uniqueKey]"
							@click="onRowClick(i)"
						>
							<td v-if="noPagination">{{ i + 1 }}</td>
							<td
								v-for="el in allProps"
								class="text-center"
								:key="el.key"
							>
								<div
									v-if="el.key === 'pic'"
									class="text-center"
								>
									<v-avatar :size="45">
										<img :src="item[el.key]" />
									</v-avatar>
								</div>
								<div
									v-if="el.key === 'appTypes'"
									class="text-center"
								>
									<div>
										{{
											item[el.key] ? item[el.key] : "N/A"
										}}
									</div>
								</div>
								<div v-else-if="el.template_type === 1">
									<v-btn
										small
										class="white--text"
										@click.stop="takeActionOnRow(i)"
										:color="themeInputColor"
										>{{ el.key }}</v-btn
									>
								</div>
								<div v-else-if="el.template_type === 2">
									<v-tooltip right>
										<v-btn icon slot="activator">
											<v-icon
												:color="
													paymentStatus[
														item['status']
													].color
												"
											>
												{{
													paymentStatus[
														item["status"]
													].icon
												}}
											</v-icon>
										</v-btn>
										<span>
											{{
												paymentStatus[item["status"]]
													.text
											}}
										</span>
									</v-tooltip>
								</div>
								<div
									v-else-if="el.template_type === 3"
									:class="
										item.paymentType === 'credit'
											? 'green--text'
											: 'red--text'
									"
								>
									<b>
										<v-icon
											size="16"
											:color="
												item.paymentType === 'credit'
													? 'green'
													: 'red'
											"
											>{{
												item.paymentType === "credit"
													? "add"
													: "remove"
											}}</v-icon
										>
										<span
											v-html="
												_getHighLightedText(
													item[el.key],
													el
												)
											"
										></span>
									</b>
								</div>
								<div
									v-else-if="el.copy_allowed"
									class="text-center"
								>
									<v-tooltip right>
										<v-btn
											small
											flat
											class="ma-0 text--normal auto-height"
											:class="{
												'no-text-transform': !el.text_transform
											}"
											slot="activator"
											@click.stop="copyText(item[el.key])"
										>
											<span
												class="wrap-word"
												v-html="
													_getHighLightedText(
														item[el.key]
													)
												"
											></span>
										</v-btn>
										<span>Click to copy</span>
									</v-tooltip>
								</div>
								<div
									v-else
									v-html="
										_getHighLightedText(item[el.key], el)
									"
								></div>
							</td>
						</tr>
					</tbody>
				</table>
			</v-flex>
		</v-layout>

		<v-layout v-if="allData.length == 0" class="allCenteredChild mb-2">
			<v-flex class="no-flex-grow">
				<v-btn disabled>No Data Found</v-btn>
			</v-flex>
		</v-layout>

		<v-layout row class="space-between" v-if="!noPagination">
			<v-layout row align-baseline>
				<span>Show</span>
				<v-flex xs1 class="mx-3">
					<v-select
						:items="limitRows"
						v-model="singlePageLimit"
						label
						prepend-icon
						:color="themeInputColor"
					></v-select>
				</v-flex>
				<span>rows out of {{ allData.length }}</span>
			</v-layout>

			<div class="text-xs-right allCenteredChild" v-if="allData.length">
				<v-pagination
					v-model="page"
					:color="themeInputColor"
					:length="totalVisible"
					:total-visible="7"
				></v-pagination>
				<v-btn
					v-if="nextOffset !== 'end' && !searchOn"
					outline
					small
					:loading="loadMoreLoading"
					@click="loadMoreRows"
					:color="themeInputColor"
					>Load More</v-btn
				>
			</div>
		</v-layout>

		<div class="allCenteredChild" v-if="hasLoadMore">
			<v-btn
				large
				outline
				:loading="loadMoreLoading"
				:disabled="nextOffset === 'end'"
				@click="loadMoreRows"
				:color="themeInputColor"
			>
				<span v-if="searchOn">
					{{
						nextOffset !== "end"
							? "SEARCH IN MORE DATA"
							: "NO MORE DATA PRESENT"
					}}
				</span>
				<span v-else>
					{{
						nextOffset !== "end" ? "LOAD MORE ROWS" : "NO MORE DATA"
					}}
				</span>
			</v-btn>
		</div>
	</div>
</template>

<script>
import { SHOW_ALERT } from "@/store/action-types";

export default {
	name: "AdvanceListView",
	props: [
		"allProps",
		"allData",
		"uniqueKey",
		"searchStr",
		"themeInputColor",
		"currentPage",
		"loadMoreLoading",
		"nextOffset",
		"searchOn",
		"totalLength",
		"selectedUserId",
		"defaultOrderByProp",
		"isTableInteractive",
		"noPagination",
		"hasLoadMore"
	],
	data() {
		return {
			page: 1,
			singlePageLimit: 10,
			limitRows: [10, 50, 100, 500],
			orderByProp: null,
			orderByDir: "asc",
			paymentStatus: {
				0: {
					icon: "error",
					text: "Failed",
					color: "red"
				},
				1: {
					icon: "check_circle",
					text: "Success",
					color: "green"
				},
				2: {
					icon: "warning",
					text: "Not Initiated",
					color: "yellow"
				}
			}
		};
	},
	mounted() {
		this.orderByProp = this.defaultOrderByProp;
		this.page = this.currentPage || 1;
	},
	computed: {
		totalVisible() {
			let total = Math.ceil(this.allData.length / this.singlePageLimit);
			if (this.page > total) {
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.page = 1;
			}
			return total;
		},
		orderedData() {
			let allData = (this.allData || []).sort((a, b) => {
				if (this.orderByDir === "asc") {
					if (typeof a[this.orderByProp] === "string") {
						if (a[this.orderByProp] < b[this.orderByProp])
							return -1;
						if (a[this.orderByProp] > b[this.orderByProp]) return 1;
					}
					return a[this.orderByProp] - b[this.orderByProp];
				} else if (this.orderByDir === "desc") {
					if (typeof a[this.orderByProp] === "string") {
						if (b[this.orderByProp] < a[this.orderByProp])
							return -1;
						if (b[this.orderByProp] > a[this.orderByProp]) return 1;
					}
					return b[this.orderByProp] - a[this.orderByProp];
				}
			});
			// console.log("allData: ", allData);
			return allData;
		},
		allSlicedData() {
			if (this.noPagination) {
				return this.orderedData;
			}

			let leftIndex = (this.page - 1) * this.singlePageLimit;
			let rightIndex = leftIndex + this.singlePageLimit;
			// console.log(this.page, leftIndex, rightIndex);
			let orderedData = this.orderedData.slice(leftIndex, rightIndex);
			// console.log("orderedData: ", orderedData);
			return orderedData;
		}
	},
	methods: {
		onRowClick(offset) {
			let index = (this.page - 1) * this.singlePageLimit + offset;
			this.$emit("ON_ROW_CLICK", index);
		},
		copyText(text) {
			try {
				let input = document.createElement("input");
				input.setAttribute("value", text);
				document.body.appendChild(input);
				input.select();
				document.execCommand("copy");
				document.body.removeChild(input);
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Copied successfully!"
				});
			} catch (e) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Error occured while copying"
				});
			}
		},
		_getHighLightedText(str, obj) {
			if (str === undefined || str === null) return "-";

			str = str + "";
			if (!str) {
				return "-";
			}

			if (obj && obj.text === "Amount") {
				return `<span style="font-size:18px;">&#8377;${str}</span>`;
			}

			if (this.searchStr && this.searchStr.length >= 1) {
				const regex = new RegExp(this.searchStr, "gi");
				return str.replace(regex, x => `<b class="highlight">${x}</b>`);
			}
			return str;
		},
		loadMoreRows() {
			this.$emit("LOAD_MORE_ROWS");
		},
		takeActionOnRow(index) {
			this.$emit("TAKE_ACTION_ON_ROW", index);
		},
		takeSecondaryAction(index) {
			this.$emit("TAKE_SECONDARY_ACTION", index);
		},
		sendMessage(index) {
			this.$emit("SEND_MESSAGE", index);
		},
		makePayment(item, type) {
			console.log(item, type);
			this.$emit("MAKE_PAYMENT", {
				user: item,
				type
			});
		},
		setOrderProperty(key) {
			if (key === this.orderByProp) {
				this.orderByDir = this.orderByDir === "asc" ? "desc" : "asc";
			} else {
				this.orderByProp = key;
				this.orderByDir = "asc";
			}
		}
	},
	watch: {
		currentPage(newVal) {
			this.page = newVal;
		}
	}
};
</script>

<style lang="scss" scoped>
table {
	border-collapse: collapse;
}
th,
td {
	text-align: left;
}
th + th,
td + td {
	text-align: center;
}
.table-default th,
.table-default td {
	padding: 15px;
}
.table-default thead th,
.table-default tr:nth-child(even) td {
	background-color: #f9f9f9;
}
.table--interactive tr:hover td {
	cursor: pointer;
	background-color: #cfd8dc;
}
.table-border th,
.table-border td {
	border: 1px solid #dedede;
}
.col-max-wid {
	max-width: 200px;
}
.sorted-column {
	text-decoration: underline;
}
</style>
